import React from "react";
import { UserType } from "@/utils/enum";
import { getAllUsersRoles } from "@/services/roles";

export default function useRoles(userType) {
  const [roles, setRoles] = React.useState([]);
  const [loadingRoles, setLoadingRoles] = React.useState(false);

  React.useEffect(() => {
    if (userType === null) {
      return;
    }

    getAllUsersRoles(userType !== UserType.Group ? userType : UserType.Dealer)
      .then(response => {
        if (Array.isArray(response)) {
          setRoles(response);
        }
      })
      .finally(() => {
        setLoadingRoles(false);
      });
  }, [userType]);

  return { roles, loadingRoles };
}
